/**
 * Lade Klon für AbschnittEdit
 * @param klonElement
 * @param sorteElement
 */
window.loadKlonOptions = function(klonElement, sorteElement) {
  const sorteValue = $(sorteElement).val();
  const klonValue = $('#data-klon').val();

  // Reset)
  $(klonElement).html('');

  $.ajax({
    url: BASE_PATH + 'ajax/helper/betriebsdaten/get.klon',
    type: 'get',
    data: {
      sorte: sorteValue,
      klon: klonValue,
    },
    dataType: 'json',
    timeout: TIMEOUT,
    error: function(jqXHR, textStatus) {
      $(config.container).html('<article class="message message--danger"><div class="message__body">' + LANG_STRINGS.errorMessage + ' (' + textStatus + ')</div></article>');
    },
    success: function(res) {
      if (res.length > 0) {
        $.each(res, function(key, value) {
          const isSelected = (value.selected !== false && value.selected !== '' ? 'selected' : '');
          const optionValue = (value.value ? value.value : '');

          $(klonElement).append('<option value="' + optionValue + '" ' + isSelected + '>' + value.label + '</option>');
        });
      }
    },
  });
};

/**
 * prepareAbschnittName
 * @param sorteName
 * @param pflanzjahr
 */
window.prepareAbschnittName = function(sorteName = '', pflanzjahr = '') {
  const prepareName = sorteName + ' ' + pflanzjahr;
  const abschnittName = $('#abschnitt-name');
  const prepareAbschnittName = abschnittName.val().substring(0, abschnittName.val().length - 5);

  let isSorteName = false;
  $('#section-sorte').find('option').each(function() {
    if (prepareAbschnittName === $(this).text()) {
      isSorteName = true;
    }
  });

  if (isSorteName === true) {
    abschnittName.val(prepareName);
  }
};